import { render, staticRenderFns } from "./inspection-list.vue?vue&type=template&id=078af564&scoped=true&"
import script from "./inspection-list.vue?vue&type=script&lang=js&"
export * from "./inspection-list.vue?vue&type=script&lang=js&"
import style0 from "./inspection-list.vue?vue&type=style&index=0&id=078af564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078af564",
  null
  
)

export default component.exports